module.exports = __webpack_public_path__ + "static/media/kingsman.db57dac5.jpg";